import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from '../../pa_checklist_followup.module.scss';
import { usePAChecklistFollowUp } from "../../pa_checklist_followup_context";
import { toast } from "react-toastify";

const PrioritySelectorAll = ({ arrPrioridade }) => {
  const { processarChecklistPriorizacao } = usePAChecklistFollowUp();
  const [modalConfirmacao, setModalConfirmacao] = useState(null);
  const [prioridadeSelecionada, setPrioridadeSelecionada] = useState({});

  const priorities = [
    { level: 0, color: '#D0D0D0', label: 'NÃO PRIORIZADO' },
    { level: 1, color: '#FFCC00', label: 'BAIXA' },
    { level: 2, color: '#FF9500', label: 'MÉDIA' },
    { level: 3, color: '#F2645E', label: 'ALTA' }
  ];

  return (
    <>
      <div style={{
        display: 'flex',
        width: '164px',
        height: '38px',
        borderRadius: '4px',
        overflow: 'hidden',
        border: '1px solid #ddd'
      }}>
        {priorities.map((priority) => (
          <div
            key={priority.level}
            onClick={() => { setModalConfirmacao(true); setPrioridadeSelecionada(priority); }}
            style={{
              flex: 1,
              backgroundColor: priority.color,
              cursor: 'pointer',
              transition: 'all 0.2s',
              borderTopLeftRadius: priority.level === 0 ? '3px' : 'none',
              borderBottomLeftRadius: priority.level === 0 ? '3px' : 'none',
              borderTopRightRadius: priority.level === 3 ? '3px' : 'none',
              borderBottomRightRadius: priority.level === 3 ? '3px' : 'none',
              // opacity: arrPrioridade[index].nova_prioridade === priority.level ? 1 : 0.7,
              // boxShadow: arrPrioridade[index].nova_prioridade === priority.level ? 'inset 0 0 0 2px #00000090' : 'none',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '500'
            }}
            title={`Priority ${priority.level}: ${priority.label}`}
          >{priority.level}</div>
        ))}
      </div>

      {
        modalConfirmacao &&
        <Modal
          size={'md'}
            onHide={() => { setModalConfirmacao(null); setPrioridadeSelecionada({}); }}
          show={modalConfirmacao}
          centered
        >
          <Modal.Header style={{ fontWeight: '500' }} closeButton>Priorização</Modal.Header>
          <Modal.Body style={{ fontWeight: '500' }}>
            Deseja alterar o nível de priorização das produções listadas para <span style={{ color: prioridadeSelecionada.color }}>{prioridadeSelecionada.label}</span>?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant={'success'}
              onClick={async () => {
                try {
                  await processarChecklistPriorizacao(arrPrioridade, prioridadeSelecionada);
                } catch (e) {
                  // toast.error('Ocorreu um erro durante a priorização, por favor tente novamente ou entre em contato com o suporte!');
                } finally {
                  setModalConfirmacao(null); setPrioridadeSelecionada({});
                }
              }}
              style={{ margin: '0px auto' }}
              className={styles.footer_btn_processamento}
            >
              Processsar Priorização
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
}

export default PrioritySelectorAll;
